interface MapIconProps {
  className?: string;
  aiId?: string;
}

export function KakaoMapIcon({ className, aiId }: MapIconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className} data-ai-id={aiId}>
      <path
        d="M12 3.2c-4.8 0-8.7 3.05-8.7 6.8 0 2.43 1.65 4.56 4.12 5.76l-.7 3.13a.5.5 0 0 0 .78.52l3.52-2.54c.32.03.65.04.98.04 4.8 0 8.7-3.05 8.7-6.81 0-3.75-3.9-6.8-8.7-6.8Z"
        fill="currentColor"
        data-ai-id={aiId ? `${aiId}-bubble-path` : undefined}
      />
      <path
        d="M8.1 8.65v3.02m2.55-3.02v3.02m0-1.54h1.9m2.08-1.48v3.02m0 0h1.7"
        stroke="white"
        strokeWidth="1.35"
        strokeLinecap="round"
        strokeLinejoin="round"
        data-ai-id={aiId ? `${aiId}-lettering-path` : undefined}
      />
    </svg>
  );
}
